<template>
  <section v-if="overviewItems.length" class="container z-grid v-page-section-container-padding">
    <div class="col-span-full 2xl:col-span-10 2xl:col-start-2">
      <div v-for="(group, index) of overviewItems" :key="index" :class="{ 'mb-16': index < overviewItems.length - 1 }">
        <AtomHeadingPageSectionLanding v-if="group.header && group.header.label" class="lg:mx-4 mb-5">{{ group.header.label }}</AtomHeadingPageSectionLanding>
        <MoleculeMatrixOverviewSectionEntries :entries="group.items" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  overviewItems: { type: Array as PropType<any[]>, required: true },
})
</script>
